import React from "react";
import { Typography, Box } from "@mui/material";

const CopyrightInfringement = () => (
    <Box sx={{ padding: '20px' }}>
        <Typography variant="h5" component="h1" gutterBottom>
            Laadu's Copyright Infringement and DMCA Policy
        </Typography>
        <Typography variant="body1" paragraph>
            Laadu respects the intellectual property of others and takes copyright violations seriously. If you think someone is using your copyrighted work without permission on our platform, the easiest way to report it is through our website. You can also send your complaint by email to dmcaquizacer@gmail.com:
        </Typography>
        <Typography variant="body1" paragraph>
            Laadu, Inc.<br />
            ATTN: DMCA Agent<br />
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
            What You Need to Include in a DMCA Complaint
        </Typography>
        <Typography variant="body1" paragraph>
            your complaint must follow Section 512(c)(3) of the Digital Millennium Copyright Act and include:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ listStyleType: 'disc', pl: 4 }}>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Your contact details:</strong> Share your full name, email, mailing address, and phone number so we and the person who posted the content can reach you.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Details about your copyrighted work:</strong> Explain clearly what copyrighted material is being misused. If there are multiple items, you can provide a list of examples.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Exact web address:</strong> Give the specific URL of the content you believe violates your copyright. A general website link isn't enough.
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Good faith statement:</strong> Include this statement: "I believe in good faith that the use of this material is not allowed by the copyright owner, their agent, or the law."
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Accuracy statement:</strong> Include this statement: "I confirm that the information in this complaint is accurate, and under penalty of perjury, I am the copyright owner or authorized to act on their behalf."
                </Typography>
            </li>
            <li>
                <Typography variant="body1" component="div">
                    <strong>Your signature:</strong> Sign the complaint, either physically or electronically, or have an authorized representative sign it.
                </Typography>
            </li>
        </Typography>

        <Typography variant="body1" paragraph>

        </Typography>
        <Typography variant="body1" paragraph>
            Laadu has a policy to suspend or terminate accounts of users who repeatedly infringe copyrights. We may share your complaint with the person who posted the content or, if we question the validity of your claim, with the copyright owner.
        </Typography>
    </Box>
);

export default CopyrightInfringement;